const Divider = (): JSX.Element => {
  return <div className="w-full border-t border-gray-300 my-6"></div>
}

export default Divider
